import { h } from 'preact'
import styles from './Banner.module.css'
import { IMatchesByDay } from '../../lib/model'
import { LogoSection } from '../LogoSection/LogoSection'
import { MatchesSection } from '../MatchesSection/MatchesSection'

interface Props {
  matches: IMatchesByDay
}

export function Banner(props: Props) {
  return (
    <div class={`${styles['dh-fotball-banner']}`}>
      <LogoSection />
      <MatchesSection matches={props.matches} />
    </div>
  )
}
